export default defineNuxtRouteMiddleware((to) => {
  const config = useRuntimeConfig()
  const localePath = useLocalePath()
  const maintenancePath = localePath('maintenance')

  if (config.public.maintenanceMode === 'true' && to.path !== maintenancePath) {
    return navigateTo(maintenancePath)
  }
})
